export default "__VITE_ASSET__BYhPlHLe__"